import { Component, OnInit } from '@angular/core';
import {Title } from "@angular/platform-browser";
import { TermsService } from '../shared/services/terms.service';
import * as AOS from 'aos';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrls: ['./terms.component.css']
})
export class TermsComponent implements OnInit {

  termDetails:any=[];
  constructor(
    private service: TermsService,
    private titleService: Title,
  ) { }

  async ngOnInit(): Promise<void> {
    this.titleService.setTitle("Terms & Privacy - SFI Compliance, Inc");
    AOS.init();
    await this.service.getTerms().then(data=>{
      this.termDetails=data;      
    })
  }
}
